import { render } from "./input-form.vue?vue&type=template&id=a9a31518&scoped=true&ts=true"
import script from "./input-form.vue?vue&type=script&lang=ts"
export * from "./input-form.vue?vue&type=script&lang=ts"

import "./input-form.vue?vue&type=style&index=0&id=a9a31518&scoped=true&lang=css"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9a31518"]])

export default __exports__